var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiaoxiang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4120_6835)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4120_6835)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 10,
    height: 16,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6L6.5 3H12.5V11L10 14H3.5V6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6L6.5 3H12.5M3.5 6H10M3.5 6V14H10M12.5 3L10 6M12.5 3V11L10 14M10 6V14",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4120_6835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4120_6835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiaoxiang);
export default __webpack_public_path__ + "static/media/jiaoxiang.7fac1b9f267fd0ff47b57126f128e006.svg";
export { ForwardRef as ReactComponent };